export const locale = {
  lang: 'pt',
  data: {
    MENU: {
      HOME: 'Casa',
      INDICADOR: 'INDICADOR'
    }
  }
}
